import { render, staticRenderFns } from "./ActionUnknown.vue?vue&type=template&id=fafc0fc0"
import script from "./ActionUnknown.vue?vue&type=script&lang=js"
export * from "./ActionUnknown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports